
import { useEffect } from 'react';

const useFlashFavicon = (normalIcon ='./favicon.ico', flashIcon = './favicon-pallet.ico', intervalMs = 500) => {
  useEffect(() => {

    let isFlashing = true;

    const link = document.querySelector("link[rel~='icon']");

    if (!link) return;

    const originalHref = link.href;

    // console.log(originalHref );

    let i = 0;

    const intervalId = setInterval(() => {

      // Toggle between icons
      link.href = isFlashing ? flashIcon : normalIcon;

    //   console.log(link.href);

      isFlashing = !isFlashing;

      i++;

      if(i > 10)
      {
          clearInterval(intervalId);
          link.href = originalHref;
      }

    }, intervalMs);

    // Cleanup: restore original favicon and clear interval when component unmounts
    return () => {
      clearInterval(intervalId);
      link.href = originalHref;
    };

  }, [normalIcon, flashIcon, intervalMs]);
}

export default useFlashFavicon;

